/* eslint-disable */
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import modules from './modules';
import plugins from './plugins';

export default {
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules,
};
